import script from "./UserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserForm.vue?vue&type=script&setup=true&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=7bbdefce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbdefce"]])

export default __exports__